module.exports = ".mat-select-panel {\r\n  margin-top: 38px;\r\n}\r\n\r\n  .mat-select-panel .mat-option {\r\n    line-height: initial;\r\n    text-align: center;\r\n    height: auto !important;\r\n    padding: 3px;\r\n    background-color: white;\r\n  }\r\n\r\n  .mat-select-panel .mat-option img {\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n\r\n  .mat-input-infix.mat-form-field-infix{\r\n    width:100%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/imageInput/imageInput.component.css
// module id = ./src/app/shared/components/imageInput/imageInput.component.css
// module chunks = main